// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 527) return "static/chunks/527.c89076874cef847e.js";
	if (chunkId === 940) return "static/chunks/940.aff25e332a08d3f7.js";
	if (chunkId === 859) return "static/chunks/859.67257adb96d1e35a.js";
	if (chunkId === 526) return "static/chunks/526.f3cb8d9e13b3603d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"18":"ce1be2649e9f5c3f","97":"ab024b036e9c3afa","240":"7942313d04a3c286","517":"13a755f7638bdb18","561":"a3d38beb0f52261a","668":"1ec524e525ed0d98","684":"bf23a90b5fc4dce8"}[chunkId] + ".js";
};